var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertSuccessFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.33301C10.81 3.33301 3.33337 10.8097 3.33337 19.9997C3.33337 29.1897 10.81 36.6663 20 36.6663C29.19 36.6663 36.6667 29.1897 36.6667 19.9997C36.6667 10.8097 29.19 3.33301 20 3.33301ZM17.5 26.1782L11.9107 20.5891L13.0894 19.4103L17.5 23.8211L26.9107 14.4103L28.0894 15.589L17.5 26.1782Z",
    fill: "#00884A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSuccessFilled);
export default __webpack_public_path__ + "static/media/alert-success-filled.dafcb2f105bbe837f6d07011620a8641.svg";
export { ForwardRef as ReactComponent };